<template>
  <NuxtImg :src="filePath" quality="90" loading="lazy" />
</template>

<script setup>
const props = defineProps(['src']);
const runtimeConfig = useRuntimeConfig();
const version = runtimeConfig.public.templateVersion;
const filePath = `/${version}/${props.src}`;
</script>
